import "./App.css";

import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { WEB_APP_URL } from "./config";

function ForCommunities() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const targetDate = new Date("2026-01-01T00:00:00").getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-black text-gray-200">
      {/* Navbar */}
      <header className="bg-black bg-opacity-70 backdrop-blur-lg sticky top-0 w-full z-50 shadow-lg">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img
              src="/images/logo.png"
              alt="Fit-Match Logo"
              className="h-16 w-auto"
            />
            <Link to="/" className="text-2xl font-bold gradient-text">
              FIT-MATCH
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#how-it-works" className="nav-link font-medium">
              How It Works
            </Link>
            <Link to="/our-story" className="nav-link font-medium">
              Our Story
            </Link>
            <Link to="/professionals" className="nav-link font-medium">
              Pros
            </Link>
            <Link to="/training-providers" className="nav-link font-medium">
              Providers
            </Link>
            <Link to="/communities" className="nav-link font-medium">
              Communities
            </Link>
            <Link to="/facilities" className="nav-link font-medium">
              Facilities
            </Link>
            <a
              href={WEB_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link font-medium px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white"
            >
              Login
            </a>
          </div>
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-white focus:outline-none"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-4 6h4"
                ></path>
              </svg>
            </button>
          </div>
        </nav>
        {/* Mobile Menu */}
        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } md:hidden bg-black bg-opacity-90 py-4`}
        >
          <Link
            to="/#how-it-works"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            How It Works
          </Link>
          <Link
            to="/our-story"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Our Story
          </Link>
          <Link
            to="/professionals"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Pros
          </Link>
          <Link
            to="/training-providers"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Providers
          </Link>
          <Link
            to="/communities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Communities
          </Link>
          <Link
            to="/facilities"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Facilities
          </Link>
          <a
            href={WEB_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block px-6 py-2 text-white font-medium nav-link"
          >
            Login
          </a>
        </div>
      </header>

      <main className="pt-24">
        {/* Hero Section */}
        <section className="hero-bg-pro py-12 md:py-20 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
          <div className="container mx-auto px-6 relative z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight">
              Share Free Events.{" "}
              <span className="gradient-text">Build Community.</span>
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-2xl mx-auto">
              Connect your community with free fitness events. Help people get
              into fitness without barriers. Completely free to join.
            </p>

            {/* Countdown Timer */}
            <div className="mt-8 mb-8">
              <h3 className="text-xl md:text-2xl font-semibold mb-4 text-white">
                Launch Countdown
              </h3>
              <div className="flex justify-center items-center space-x-4 md:space-x-8">
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.days}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">Days</div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.hours}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Hours
                  </div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.minutes}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Minutes
                  </div>
                </div>
                <div className="bg-gray-800 bg-opacity-80 rounded-lg p-4 md:p-6 text-center min-w-[80px] md:min-w-[100px]">
                  <div className="text-2xl md:text-4xl font-bold text-blue-fit-match">
                    {timeLeft.seconds}
                  </div>
                  <div className="text-sm md:text-base text-gray-300">
                    Seconds
                  </div>
                </div>
              </div>
              <p className="text-sm md:text-base text-gray-300 mt-4">
                Until January 1st, 2026
              </p>
              <div className="mt-4 p-4 bg-green-600 bg-opacity-20 border border-green-500 border-opacity-50 rounded-lg">
                <p className="text-white font-semibold text-sm md:text-base">
                  Community membership is completely FREE! Join us and help make
                  fitness accessible to everyone.
                </p>
              </div>
            </div>

            <div className="mt-8">
              <Link
                to="/preregister-community"
                className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
              >
                Join as Community Organizer
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="py-20 bg-gray-950">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Features for Community Organizers
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 7V3m8 4V3m-9 8h.01M3 21h18a2 2 0 002-2V8.656a2 2 0 00-.606-1.424l-3.342-3.342A2 2 0 0013.586 3H10.414A2 2 0 009 5.828v2.172a2 2 0 00-.606 1.424l-3.342 3.342A2 2 0 003 16.344V21z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Free Event Listings
                </h3>
                <p className="text-gray-400 text-center">
                  Add your free community fitness events to the map. Events are
                  visible for up to 30 days, helping people in your area discover
                  accessible fitness opportunities.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Map Visibility
                </h3>
                <p className="text-gray-400 text-center">
                  Your events appear on the interactive map, making it easy for
                  community members to find free fitness activities in their
                  local area.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v12m-3-2.818l.818.182a2.5 2.5 0 004.364 0l.818-.182M12 6.75V6m0 12.75V18m0-12.75a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm0 12.75a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Completely Free
                </h3>
                <p className="text-gray-400 text-center">
                  No membership fees, no charges, no hidden costs. Community
                  organizers join for free to help make fitness accessible to
                  everyone.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  30-Day Event Duration
                </h3>
                <p className="text-gray-400 text-center">
                  Events are automatically displayed for up to 30 days, keeping
                  the map fresh and relevant while giving your event maximum
                  visibility.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.645-5.963-1.76A8.967 8.967 0 016 18.72m3 0H5.904a9.094 9.094 0 001.741-.479 3 3 0 004.682 2.72m-3 .479V18.72a9.094 9.094 0 00-.479-1.741 3 3 0 00-2.72-4.682m3 .479l-.001.031c0 .225.012.447.037.666A11.944 11.944 0 0112 15c2.17 0 4.207.645 5.963 1.76M8 10.5h.01M15 10.5h.01M12 10.5h.01"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  Community Focus
                </h3>
                <p className="text-gray-400 text-center">
                  Events must be completely free for attendees. This platform is
                  designed to help people get into fitness without financial
                  barriers.
                </p>
              </div>
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300">
                <div className="text-blue-fit-match text-4xl mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 mx-auto"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold mb-2 text-center">
                  No Advertising Restrictions
                </h3>
                <p className="text-gray-400 text-center">
                  You cannot advertise prices or services. This platform is
                  exclusively for free community events that help people access
                  fitness without cost.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Screenshots Section */}
        <section id="screenshots" className="py-20 bg-black">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-12">
              Community Events on the Map
            </h2>
            <div className="flex flex-wrap justify-center items-center gap-12">
              <div className="app-screenshot-frame -rotate-3 transform transition duration-300 hover:rotate-0 relative">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/facility-map.png')",
                  }}
                ></div>
                <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center rounded-[30px]">
                  <span className="text-white text-2xl md:text-3xl font-bold">
                    Coming Soon
                  </span>
                </div>
              </div>
              <div className="app-screenshot-frame rotate-6 transform transition duration-300 hover:rotate-0 relative">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/facility-profile.png')",
                  }}
                ></div>
                <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center rounded-[30px]">
                  <span className="text-white text-2xl md:text-3xl font-bold">
                    Coming Soon
                  </span>
                </div>
              </div>
              <div className="app-screenshot-frame -rotate-6 transform transition duration-300 hover:rotate-0 relative">
                <div
                  className="app-screenshot-inner"
                  style={{
                    backgroundImage:
                      "url('/images/screenshots/manage-pros.png')",
                  }}
                ></div>
                <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center rounded-[30px]">
                  <span className="text-white text-2xl md:text-3xl font-bold">
                    Coming Soon
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-20 bg-gray-950">
          <div className="container mx-auto px-6 text-center max-w-4xl">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ready to Share Free Fitness Events?
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed mb-8">
              Join our community of organizers dedicated to making fitness
              accessible to everyone. Help people discover free fitness
              opportunities in their area. No cost, no barriers, just community
              support.
            </p>
            <Link
              to="/preregister-community"
              className="bg-blue-fit-match text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-blue-600 transition duration-300"
            >
              Join as Community Organizer
            </Link>
          </div>
        </section>

        {/* Free Membership Section */}
        <section className="py-20 bg-black">
          <div className="container mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Community Membership
            </h2>
            <div className="max-w-2xl mx-auto">
              <div className="bg-gray-800 p-8 rounded-xl shadow-xl transform hover:scale-105 transition duration-300 border border-green-500 border-opacity-50">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold mb-2 text-green-400">
                    FREE Community Membership
                  </h3>
                  <div className="text-4xl font-bold text-white mb-2">£0</div>
                  <div className="text-gray-400 text-sm">Forever Free</div>
                </div>
                <div className="mb-6">
                  <h4 className="text-lg font-semibold mb-3 text-white">
                    What's Included
                  </h4>
                  <ul className="text-gray-400 text-sm leading-relaxed space-y-2">
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>
                        Free Event Listings - Add unlimited free community
                        events to the map
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>
                        Map Visibility - Events shown for up to 30 days
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>
                        Community Focus - Help people access fitness without
                        financial barriers
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>
                        No Advertising - Events must be completely free for
                        attendees
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-green-400 mr-2">•</span>
                      <span>
                        No Restrictions - Cannot advertise prices or services,
                        only free events
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="border-t border-gray-700 pt-4">
                  <h4 className="text-lg font-semibold mb-2 text-white">
                    Community Guidelines
                  </h4>
                  <p className="text-gray-400 text-sm">
                    All events must be completely free for community members.
                    This platform is designed to help people get into fitness
                    without spare cash. Events are automatically removed after
                    30 days to keep the map fresh and relevant.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 py-8 text-center text-gray-400">
        <p>&copy; 2024 Fit-Match. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default ForCommunities;

